import { motion } from "framer-motion";
import { useLang, tr } from "@/i18n";

const stats = [
    { value: "45+", label: "Sacred Vedis" },
    { value: "9", label: "Ritual Packages" },
    { value: "40–60", label: "Transparent Pricing" },
];

export const StatsStrip = () => {
    const { lang } = useLang();
    const t = (s) => tr(lang, s);
    return (
        <section data-testid="stats-strip" className="bg-[#FFF8E7] border-b border-[#E5C158]/60 py-10">
            <div className="max-w-5xl mx-auto px-6 grid grid-cols-3 divide-x divide-[#E5C158]/70">
                {stats.map((s, i) => (
                    <motion.div
                        key={s.label}
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                        className="text-center px-2"
                    >
                        <p className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#9C370B]">
                            {s.value}
                        </p>
                        <p className="mt-1.5 text-[10px] sm:text-xs uppercase tracking-[0.22em] text-[#6E6259]">
                            {t(s.label)}
                        </p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};
